// extracted by mini-css-extract-plugin
module.exports = {"logoCTA":"HeaderLeft_logoCTA__VgSdQ","textButton":"HeaderLeft_textButton__mywLB"};